<script setup>
import SInfoMontant from '@/components/global/s-info-montant.vue'
</script>

<template>
  <tr>
    <td>{{ posteAVerser.posteAim.libelle }}</td>
    <td>
      <v-text-field dense hide-details type="number" :value="posteAVerser.montant" @input="changerMontantAVerser" />
    </td>
    <td><s-info-montant :montant="montantParVersement" /></td>
  </tr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'poste-a-verser-tab-item',
  data() {
    return {
      loading: false,
    }
  },
  props: {
    posteAVerser: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      nbVersements: 'preparationVersement_IHM_helper/getNombreVersements',
    }),
    montantParVersement() {
      if (this.nbVersements > 0 && this.posteAVerser.montant > 0) return this.posteAVerser.montant / this.nbVersements
      return 0
    },
  },
  methods: {
    ...mapActions({
      changerMontantPoste: 'preparationVersement_IHM_helper/changerMontantPoste',
    }),
    changerMontantAVerser(newMontant) {
      this.loading = true
      this.changerMontantPoste({
        _poste: this.posteAVerser.posteAim,
        _montant: newMontant,
      }).then(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style scoped></style>
